export default function Pencil() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.6427 15.658L1.33203 16.6693L2.34336 12.3593L12.9747 1.72665C13.2248 1.47649 13.564 1.33594 13.9177 1.33594C14.2714 1.33594 14.6106
                1.47649 14.8607 1.72665L16.2754 3.14065C16.5255 3.39072 16.6661 3.72994 16.6661 4.08365C16.6661 4.43737 16.5255 4.77659 16.2754
                5.02665L5.6427 15.658Z"
                stroke="#0063AD"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.8059 5.49665L12.5039 2.19531"
                stroke="#0063AD"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.8526 6.45062L11.5586 3.14062"
                stroke="#0063AD"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.81172 15.4875L2.51172 12.1875"
                stroke="#0063AD"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
